import React from "react";

// --- CSS --- //
import "../../styles/pricing.css";

// --- ASSETS --- //
import mockup_3 from "../../assets/mockup-3.png";

import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

const Pricing = () => {
    return (
        <>
            {/* Hero Section */}
            <section className="hero">
                <div className="hero-content">
                    <h1>Choose the Perfect Plan for You</h1>
                    <p>Whether you're a climber looking to get certified or a gym ready to offer certifications, VERT CERT has the right plan to support your journey.</p>
                    <a href="/sign-up">
                        <button className="cta-button">Sign Up Now</button>
                    </a>
                </div>
                <div className="hero-image">
                    <img src={mockup_3} alt="App Mockup" />
                </div>
                <div className="hero-scroll-down">
                    <KeyboardArrowDownIcon style={{ fontSize: "30pt" }} />
                </div>
            </section>

            {/* Climber Pricing Section */}
            <section className="pricing-climbers">
                <h2 className="price-section-title">For Climbers</h2>
                <div className="pricing-cards">
                    <div className="pricing-card">
                        <h3>Free Plan</h3>
                        <p>View, track, and manage your certifications with ease. Access basic features at no cost.</p>
                        <ul>
                            <li>Track certifications</li>
                            <li>Search for participating gyms</li>
                            <li>Basic support</li>
                        </ul>
                        <a href="/sign-up">
                            <button className="cta-button">Sign Up Now</button>
                        </a>
                    </div>
                    <div className="pricing-card">
                        <h3>Premium</h3>
                        <p>Unlock premium features, faster updates, and priority support.</p>
                        <ul>
                            <li>Track certifications</li>
                            <li>Search for participating gyms</li>
                            <li>Priority support</li>
                            <li>Real-time updates</li>
                        </ul>
                        <button className="cta-button">Contact Us</button>
                    </div>
                </div>
            </section>

            {/* Gym Pricing Section */}
            <section className="pricing-gyms">
                <h2 className="price-section-title">For Gyms</h2>
                <div className="pricing-cards">
                    <div className="pricing-card">
                        <h3>Free Trial</h3>
                        <p>Try VERT CERT for free and explore our best features before making a decision.</p>
                        <ul>
                            <li>All our GOLD features FREE for 1 month</li>
                            <li>Priority support</li>
                        </ul>
                        <a href="/contact">
                            <button className="cta-button">Contact Us</button>
                        </a>
                    </div>
                    <div className="pricing-card">
                        <h3>Plus</h3>
                        <p>For small gyms looking to expand their certification capabilities with essential features.</p>
                        <ul>
                            <li>Access to full gym tools</li>
                            <li>Priority email support</li>
                            <li>Priority access to new features</li>
                        </ul>
                        <button className="cta-button">Contact Us</button>
                    </div>
                    <div className="pricing-card">
                        <h3>Premium</h3>
                        <p>For medium-sized gyms needing advanced tools and extensive support.</p>
                        <ul>
                            <li>Access to advanced gym management features</li>
                            <li>Priority phone and email support</li>
                            <li>Access to exclusive features</li>
                            <li>Support for updated gym information</li>
                        </ul>
                        <button className="cta-button">Contact Us</button>
                    </div>
                    <div className="pricing-card">
                        <h3>Gold</h3>
                        <p>For large gyms with a high volume of climbers and the need for comprehensive management tools.</p>
                        <ul>
                            <li>Unlimited climber certifications</li>
                            <li>Advanced analytics and reporting</li>
                            <li>Dedicated support team</li>
                            <li>Access to all features and updates</li>
                            <li>Support for updated gym information</li>
                        </ul>
                        <button className="cta-button">Contact Us</button>
                    </div>
                </div>
            </section>

            {/* Call-to-Action Section */}
            <section className="cta">
                <h2>Ready to Get Started?</h2>
                <p>Select the plan that best fits your needs, and start your journey with VERT CERT today.</p>
                <a href="/sign-up">
                    <button className="cta-button" id="cta-sign-up-button">Sign Up Now</button>
                </a>
            </section>
        </>
    );
};

export default Pricing;